export default "/assets/images/mila-manual.0ee671e9b541b62f.png";